import React, { useRef, useState, useCallback, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import BookingModal from '@/components/BookingModal';

import { MENU } from './consts';
import { Nav, Wrapper, LinkWrap, NavLink, BookingButton, Label, Icon, CloseButton } from './styles';

const Menu = ({ pathname, isOpenMenu, setOpenMenu }) => {
  const ref = useRef(null);
  const [isBookingOpen, setBookingOpen] = useState(false);
  const closeMenu = useCallback(() => {
    if (typeof setOpenMenu === 'function') {
      setOpenMenu(false);
    }
  }, [setOpenMenu]);
  const closeBooking = useCallback(() => setBookingOpen(false), []);
  const handleBooking = useCallback(() => {
    closeMenu();
    setBookingOpen(true);
  }, [closeMenu]);

  useLayoutEffect(() => {
    if (isOpenMenu && typeof setOpenMenu === 'function') {
      ref.current?.scrollTo(0, 0);
    }
  }, [isOpenMenu, setOpenMenu]);

  return (
    <>
      <Nav ref={ref} $isOpen={isOpenMenu}>
        <Wrapper>
          <LinkWrap>
            {MENU.map(({ isBooking, url, name, checkActive }) =>
              isBooking ? (
                <BookingButton key={name} type="button" onClick={handleBooking}>
                  <Label>{name}</Label>
                  <Icon />
                </BookingButton>
              ) : (
                <NavLink key={url} to={url} onClick={closeMenu} $isActive={checkActive(pathname)}>
                  {name}
                </NavLink>
              )
            )}
          </LinkWrap>
          {typeof setOpenMenu === 'function' && (
            <CloseButton type="button" onClick={closeMenu}>
              Schliessen
            </CloseButton>
          )}
        </Wrapper>
      </Nav>
      {isBookingOpen && <BookingModal onClose={closeBooking} />}
    </>
  );
};

Menu.defaultProps = {
  isOpenMenu: false,
  setOpenMenu: null,
};
Menu.propTypes = {
  pathname: PropTypes.string.isRequired,
  isOpenMenu: PropTypes.bool,
  setOpenMenu: PropTypes.func,
};

export default Menu;
